<template>
  <div class="onboarding-load-error">
    <PromoLogo full class="logo" />

    <h2>Well this is embarrasing 🙈</h2>

    <p>It looks like we had an issue setting up your account.</p>

    <p>
      Please refresh the page or
      <button class="text-brand font-lato" @click="retry">click here</button> to
      try again.
    </p>

    <p>
      If the problem persists please
      <a
        class="font-lato"
        href="mailto:support@promo.ai?subject=Promo.ai Onboarding Error"
        >email us</a
      >
      and a member of our team will get back to you.
    </p>
    <p class="mb-2">💸💸💸</p>
    <p>
      <strong
        >As a thank you we will also give you a free subscription for your first
        month 🙏</strong
      >
    </p>
  </div>
</template>

<script>
import PromoLogo from "@/components/UI/PromoLogo";

export default {
  name: "OnboardingLoadError",
  components: { PromoLogo },
  methods: {
    retry() {
      window?.document?.location?.reload();
    }
  }
};
</script>

<style scoped>
.onboarding-load-error {
  @apply bg-white absolute w-full h-full text-center pt-8;
  z-index: 99999;
}

.logo {
  @apply block mx-auto mb-8;
  width: 233px;
}
</style>
